"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const state_1 = __importDefault(require("../state"));
const levelIsCompleted = () => state_1.default.brokenDestructibleIDs.length === state_1.default.level.requiredDestructibles;
exports.default = levelIsCompleted;
